import { render } from "./NewBatch.vue?vue&type=template&id=3ea75b39"
import script from "./NewBatch.vue?vue&type=script&lang=js"
export * from "./NewBatch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__